// import React, { useState } from 'react'
// import { Line } from 'react-chartjs-2';
// import { Chart as ChartJS} from 'chart.js/auto';

// const  userData = [
//     {
//         id:1,
//         months:"FEB",
//         userGain:8000,
//         userLost:823,
//         borderColor: '#fff',
//         backgroundColor: 'rgba(255, 99, 132, 0.5)',
//     },
//     {
//         id:2,
//         months:"MAR",
//         userGain:7000,
//         userLost:500,  
//         borderColor: 'rgb(53, 162, 235)',
//         backgroundColor: 'rgba(53, 162, 235, 0.5)',
//     },
    
//     {
//         id:3,
//         months:"APR",
//         userGain:1000,
//         userLost:400,  
//         borderColor: 'rgb(255, 99, 132)',
//         backgroundColor: 'rgba(255, 99, 132, 0.5)',
//     },
//     {
//         id:4,
//         months:"MAY",
//         userGain:80766,
//         userLost:400, 
//         borderColor: 'rgba(53, 162, 235, 0.5)',
//         backgroundColor: 'rgba(53, 162, 235, 0.5)', 
//     },
//     {
//         id:5,
//         months:"JUN",
//         userGain:1000,
//         userLost:400, 
//         borderColor: 'rgb(53, 162, 235)',
//         backgroundColor: 'rgba(53, 162, 235, 0.5)', 
//     }
// ]

// export default function Chart() {
//   const [userDataList,setUserDataList] = useState({
//     labels:userData.map((data)=>data.months),
//     datasets:[{
//         label:'Users Gained',
//         data:userData.map((data)=>data.userGain),
//         borderColor: userData.map((data)=>data.borderColor),
//         backgroundColor:userData.map((data)=>data.backgroundColor),
//     }]
//   });

//   const options = {
//     plugins: {
//       legend: {
//         display: false,
//       },
//     },
//   };
//   return (
//     <Line data={userDataList} options={options} />
//   )

// }



import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import styled from 'styled-components';

const Root = styled.div`
width:80%;
`;

const  userData1 = [
  {
      id:1,
      year:2016,
      userGain:80000,
      userLost:823,
      borderColor: '#fff',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
  },
  {
      id:2,
      year:2017,
      userGain:700000,
      userLost:500,  
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
  },
  
  {
      id:3,
      year:2018,
      userGain:1000000,
      userLost:400,  
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
  },
  {
      id:4,
      year:2019,
      userGain:80766,
      userLost:400, 
      borderColor: 'rgba(53, 162, 235, 0.5)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)', 
  },
  {
      id:5,
      year:2020,
      userGain:100000,
      userLost:400, 
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)', 
  }
]
const  userData2 = [
  {
      id:1,
      year:2016,
      userGain:50000,
      userLost:823,
      borderColor: '#fff',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
  },
  {
      id:2,
      year:2017,
      userGain:90000,
      userLost:500,  
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
  },
  
  {
      id:3,
      year:2018,
      userGain:40000,
      userLost:400,  
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
  },
  {
      id:4,
      year:2019,
      userGain:70000,
      userLost:400, 
      borderColor: 'rgba(53, 162, 235, 0.5)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)', 
  },
  {
      id:5,
      year:2020,
      userGain:110000,
      userLost:400, 
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)', 
  }
]
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);


const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export const data = {
  labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: userData1.map((data)=>data.userGain),
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
    },
    {
      label: 'Dataset 2',
      data: userData2.map((data)=>data.userGain),
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
  ],
};
export default function LineChart() {
  return (
   <Root>
    <Line data={data} />
    </Root>
  )
}
